export function MagazineStyle(theme) {
  return {
    base: {
      backgroundColor: theme.backgroundColor.base,
      border: `1px solid ${theme.borderColor.base}`,
      outline: 'none',
      boxSizing: 'border-box',
      margin: 0,
      overflow: 'auto',
      padding: 0,
      boxShadow: `
      ${theme.depth.boxShadow.hard.xOffset}
      ${theme.depth.boxShadow.hard.yOffset}
      ${theme.depth.boxShadow.hard.blurRadius}
      ${theme.depth.boxShadow.hard.spreadRadius}
      ${theme.depth.boxShadow.hard.color}`,
      display: 'block',
      paddingTop: '.5rem',
      paddingBottom: '.5rem',
      textAlign: 'left',
      direction: 'ltr',
      position: 'absolute',
      zIndex: parseInt(theme.depth.zIndex[800], 10) + 1
    },
    rtl: {
      textAlign: 'right',
      direction: 'rtl'
    }
  };
}

export default MagazineStyle;
